//@ts-check;
import { ModalHelper } from "../../B2bTools";
import { createApp } from "vue";

import html from "./codification.html";
//
import htmlSorter from "./codification@sorter.html";
//
//
import { may, traduit } from "../composant/b2bLangue";
import draggable from 'vuedraggable'


const js = ({
    url: function (echangeur) {
        echangeur.addAction('b2b.tri.get', { k: "department" }, '', 'department');
        echangeur.addAction('b2b.tri.get', { k: "family" }, '', 'family');
        echangeur.addAction('b2b.tri.get', { k: "macrofamily" }, '', 'macrofamily');
        echangeur.addAction('b2b.tri.get', { k: "collectiontype" }, '', 'collectiontype');
    },
    onLoad: function (echangeur) {

        let THIS = this;

        const app = createApp({
            data: () => ({
                datas: {
                    classes: [
                        {
                            title: "Departments",
                            rows: echangeur.department,
                            action: "departmentsSort",
                            withv: true
                        },
                        {
                            title: "Macro Families",
                            rows: echangeur.macrofamily,
                            action: "macrofamilySort",
                            withv: false
                        },

                        {
                            title: "Families",
                            rows: echangeur.family,
                            action: "familySort",
                            withv: true
                        },
                        {
                            title: "Collection Types",
                            rows: echangeur.collectiontype,
                            action: "collectiontypeSort",
                            withv: false
                        }

                    ]
                },
                isEditeur: may("MAJSEASON"),
            }),

            methods: {
                tri(item) {
                    if (item.action == "departmentsSort") {
                        this.ParamSort("department");
                    };
                    if (item.action == "familySort") {
                        this.ParamSort("family");
                    };
                    if (item.action == "macrofamilySort") {
                        this.ParamSort("macrofamily");
                    };
                    if (item.action == "collectiontypeSort") {
                        this.ParamSort("collectiontype");
                    };
                },
                async ParamSort(classe) {
                    if (!this.isEditeur) return;
                    if (!classe) return;
                    const thisParent = this;
                    const tries = await THIS.rest("b2b.tri.get", { k: classe });

                    let modaltitle = classe;
                    let withv = true;
                    let rows = await THIS.rest("b2b.tri.groupe", { "classe": classe });

                    for (const existant of rows) {
                        if (existant.k != "" && !tries.find(u => u.k == existant.k)) {
                            if (!existant.v || existant.v == "") existant.v = existant.k;
                            tries.push(existant);
                        }
                    }
                    // rows.forEach(element => {
                    //     element.error = {}
                    // });
                    const modaleApp = createApp({

                        data: function () {
                            return {
                                title: modaltitle,
                                withv: withv,
                                rows: tries,
                                options: {
                                },
                                drag: false,
                            }
                        },
                        components: {
                            draggable,
                        },
                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },
                            async saveForm(e) {
                                e.preventDefault();
                                //console.log("a");

                                let nbError = 0;
                                for (let item of this.rows) {
                                    item.error = {};
                                    // if (!item.v) item.error.v = 'Required';
                                    function nbe(objet) {
                                        let nb = 0;
                                        for (let key in objet) if (objet[key]) nb++;
                                        return nb;
                                    }
                                    nbError += nbe(item.error);
                                }

                                if (!nbError) {
                                    const data = {
                                        rows: this.rows.map(u => ({ k: u.k, v: u.v, })),
                                    }
                                    //console.log('save:' + JSON.stringify(data));
                                    const result = await THIS.rest("b2b.tri.save", { "k": classe }, data);
                                    //console.log('result:' + JSON.stringify(result));
                                    let index = ["department", "macrofamily", "family", "collectiontype"].indexOf(classe);
                                    //console.log("index:" + index);

                                    thisParent.datas.classes[index].rows = data.rows;
                                    //console.log(JSON.stringify(data));
                                    this.close();
                                } else {
                                    //console.log("error");
                                }

                            },
                        },
                        mounted() {
                            if (this.rows == 0) this.addRow()
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlSorter).container);
                },
                t(value) {
                    return traduit(value, 'global');
                }

            },

        });
        app.mount(THIS.c$('._vueChargement')[0]);
    },
    reprise: async function (ecran, echangeur) {
        //
        this.vm.$data.datas = form;
        //
        this.toggle(true);
        ecran.restaure();
        //
    }

});
export default {
    codification: { js: js, html: html }
};



